"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var contextManage_1 = require("../../contextManage");
var next_1 = require("@alifd/next");
var components_img_thumb_1 = require("@aligov/components-img-thumb");
// 照片列表组件
var PicList = function (props) {
    //删除照片
    var delPicHandler = function (item, index) {
        var newList = props.gpyPicList.slice();
        newList.splice(index, 1);
        props.setGpyPicList(newList);
    };
    var context = react_1.useContext(contextManage_1.DeviceTaskContext);
    return (React.createElement("div", { className: "right" },
        React.createElement("div", { className: "pic_count_div" },
            "\u5DF2\u62CD\u6444\uFF08",
            props.gpyPicList.length,
            "/",
            props.gpyTotal,
            "\uFF09"),
        React.createElement("div", { className: "pic_content_div" }, props.gpyPicList.length > 0 ?
            props.gpyPicList.map(function (item, index) {
                return (React.createElement("div", { className: "pic_item_div", key: index },
                    React.createElement(components_img_thumb_1.default, { className: "pic_item_img_thumb", width: 105, height: 105, src: item }),
                    React.createElement("div", { className: "delete-filling-div", onClick: function () { delPicHandler(item, index); } },
                        React.createElement(next_1.Icon, { type: "delete-filling", size: "small", className: "icon_bg_fill" }))));
            })
            :
                React.createElement("div", { className: "nodata_div" },
                    React.createElement("div", { className: "nodata" }),
                    "\u6682\u65E0\u56FE\u50CF"))));
};
exports.default = PicList;
